import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/case-img.jpg";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>
                Target Maximum Audience with Engaging Mobile App Solutions
              </h2>
            </div>
            <p>
              Our experienced app developers in Atlanta understand the
              significance of customer engagement via mobile phones. Therefore,
              we create a UI that encourages user interaction and UX that is
              memorable. People today prefer to access everything online rather
              than physically visiting a place. That’s where you can gain the
              maximum attention of the users by providing them with your
              services online. With our mobile application in Atlanta, you can
              give a real-time experience to your customers and make them feel
              proud of their decision.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
